import { Component, OnInit } from '@angular/core';
import { features } from '@app/consts/features';
import { modules } from '@app/consts/modules';
import { OidcAuthService } from '@app/core/services/oidc-auth.service';
@Component({
  selector: 'app-time-off-homepage-section',
  templateUrl: './time-off-section.component.html',
  styleUrls: ['./time-off-section.component.scss']
})
export class TimeOffHomepageSectionComponent implements OnInit {
  public features: typeof features = features;
  public modules: typeof modules = modules;
  refreshMyTimeOffRequest: boolean = false;
  refreshMyToilRequest: boolean = false;
  user$: any;
  

  constructor(
    private oidcAuthService: OidcAuthService
  ) {
    this.user$ = this.oidcAuthService.userProfile;
  }

  ngOnInit(): void {
  }

  timeOffRequestCreated(event: boolean) {
    this.refreshMyTimeOffRequest = !this.refreshMyTimeOffRequest;
  }

  toilRequestCreated(event: boolean) {
    this.refreshMyToilRequest = !this.refreshMyToilRequest;
  }

}
